
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modes-de-livraison",
      function () {
        return require("private-next-pages/modes-de-livraison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modes-de-livraison"])
      });
    }
  